import { render } from "./AboutSectionCMS.vue?vue&type=template&id=2fa31df8"
import script from "../js/about-section-cms.js?vue&type=script&lang=js"
export * from "../js/about-section-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__